<template>
  <div class="s-advice">
    <!-- <div class="advice-pic"></div> -->
    <div class="s-advice2">
      <div class="close iconfont icon-close-line" @click="hide"></div>
      <h3 class="advice-title">意见反馈</h3>
      <textarea class="advice-box" placeholder="请留下你的建议" v-model="content"></textarea>
        <div class="concat-info">
          <span class="t1">拨打电话：</span>
          <div class="tt">
            <div class="phone ico ico-tel blue"></div>
            <a href="tel:0745-8889853" class="t2">0745-8889853</a>
          </div>
        </div>
      <van-button class="advice-btn" :disabled="locking" @click="submit">确认提交</van-button>
    </div>
  </div>
</template>

<script>
export default {
  props: { },
  data(){
    return{
      content:'',
      locking:false
    }
  },
  methods:{
    hide(){
      this.$emit("hide")
      setTimeout(() => {
        this.content=''
        this.locking = false
      }, 500);
    },
    submit(){
      if(!this.content || !this.content.trim()){
        this.$toast("内容不能为空")
        return
      }
      this.locking = true
      this.$api.userApi.getSuggestion({content:this.content}).then(res=>{
        if(res && res.code==0){
          this.$toast.success("提交成功")
          setTimeout(() => {
            this.hide()
          }, 500);
        }else{
          this.$toast.fail(res.msg)
          this.locking = false
        }
      })
      
    }

  },
}
</script>
<style scoped lang="scss">
.s-advice{
  // padding-bottom: 100rem;
  .s-advice2{
    background: #F5F1EE;
    border: 2rem solid var(--mainColor);
    border-radius: 15rem;
    width: calc(100vw - 21rem * 2);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    position: relative;
    padding: 15rem 20rem;
    max-width: var(--maxWidth);
      margin: 0 auto;
  }
  .close{
    position: absolute;
    z-index: 3;
    right: 15rem;
    top:  10rem;
    color: #777;
    font-size: 24rem;
    cursor: pointer;
  }
  .advice-pic{
    width: 100%;
    height: 110rem;
    z-index: 2;
    position: relative;
    top: 1rem;
    background: url(../assets/images/advicebg.png) center bottom no-repeat;
    background-size: contain;
  }
  .advice-title{
    text-align: center;
    font-size: 18rem;
    font-weight: bold;
    color: #3D3D3D;
    margin-bottom: 17rem;
  }
  .advice-box{
    background: #EEE4CE;
    border-radius: 5rem;
    height: 170rem;
    width: 100%;
    box-sizing: border-box;
    padding: 5rem;
    font-size: 14rem;
    color:#4b4b4b ;
    line-height: 1.8;
    
  }
  textarea::placeholder{
      color: #9c9c9c;
    }
  .advice-btn{
    width: 167rem;
    height: 34rem;
    background: var(--mainColor);
    border: none;
    color: #FFFFE3;
    font-size: 14rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 30rem;
    margin: 0 auto;
    margin-top: 26rem;
    cursor: pointer;
    &:active{
      background: var(--organColorDark);
    }
  }
}

    .concat-info{
      display: flex;
      // justify-content: center;
      // flex-direction: column;    
      align-items: center;
      margin-top: 20rem;
      .t1{
        font-size: 14rem;
        font-weight: 500;
        color: #222;
      }
      .tt{
        display: flex;
        align-items: center;
        color: var(--blueColor);
        cursor: pointer;
        .t2{
          font-size: 20rem;
          font-family: 'HarmonyOS Sans SC';
          color: var(--blueColor);
        }
        .phone{
          font-size: 20rem;
          margin-right: 5rem;
          width: 20rem;
          height: 20rem;
        }
      }
    }

</style>